"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LinksGrid = _interopRequireDefault(require("./LinksGrid/LinksGrid"));
var _Slider = _interopRequireDefault(require("./Slider/Slider"));
var _MarterpreisArticles = _interopRequireDefault(require("./MarterpreisArticles/MarterpreisArticles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SIAMasterpreisHomepage = _ref => {
  let {
    item,
    lang,
    translate,
    getMasterpreisArticles
  } = _ref;
  const [articles, setArticles] = (0, _react.useState)([]);
  const getArticles = async () => {
    const data = await getMasterpreisArticles();
    setArticles(data);
  };
  (0, _react.useEffect)(() => {
    getArticles();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-masterpreis-homepage"
  }, /*#__PURE__*/_react.default.createElement(_Slider.default, {
    items: item.masterpreis_articles,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_LinksGrid.default, {
    links: item.links,
    lang: lang
  }), articles.length > 0 && /*#__PURE__*/_react.default.createElement(_MarterpreisArticles.default, {
    articles: articles,
    lang: lang,
    translate: translate
  }));
};
var _default = exports.default = SIAMasterpreisHomepage;